// extracted by mini-css-extract-plugin
export default {"btnpwd":"_9edbf3720b"};